import { ImpOfferPage, ImpSpacer } from '@imprint-payments/imprint-ui';
import { useEffect, useState } from 'react';

import { EVENT } from '../../analytics/analyticsConsts';
import { getCardDesignOptions } from '../../api/api';
import { setCardDesignSelection } from '../../app/acceptScreenSlice';
import { useAppSelector, useImpState } from '../../app/hooks';
import { MerchantData } from '../../app/merchantDataSlice';
import { webServicingDisplayURL } from '../../assets/consts/const';
import { ANALYTICS } from '../../firebase/firebase';
import OfferNotAcceptedPage, {
  OfferNotAcceptedPageProps,
} from '../../pages/onboarding/OfferNotAcceptedPage';
import { PRODUCT_UUID } from '../../utils/productUUIDConstants';
import InStoreModal from '../application/InStoreModal';
import Confetti from '../Confetti/Confetti';
import { useOfferPageProps } from './OfferHeaderUtils';

export default function OfferHeader() {
  const { merchantData, consumerInfo, dispatch } = useImpState();
  const [openInStoreModal, setOpenInStoreModal] = useState(false);
  const [openOfferNotAccepted, setOpenOfferNotAccepted] = useState(false);
  const expiresAt = useAppSelector(
    (state) => state.applicationStatusSelector.expiresAt
  );

  useEffect(() => {
    ANALYTICS.logEvent(EVENT.OFFER_VIEWED);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (
      consumerInfo.cardOffer.cardDesignOptions &&
      consumerInfo.cardOffer.cardDesignOptions.length > 1
    ) {
      for (const cardDesignOption of consumerInfo.cardOffer.cardDesignOptions) {
        const productUUID = merchantData.productUUID;
        dispatch(
          getCardDesignOptions(cardDesignOption.cardDesignID, productUUID)
        );
      }
      dispatch(setCardDesignSelection(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consumerInfo.cardOffer]);

  function getConfetti() {
    switch (merchantData.productUUID) {
      case PRODUCT_UUID.HEB:
      case PRODUCT_UUID.CM:
        return <Confetti />;
      default:
        return null;
    }
  }

  const offerPageProps = useOfferPageProps({
    sdkSecondaryAction: () => {
      setOpenOfferNotAccepted(true);
    },
    setOpenInStoreModal: () => {
      setOpenInStoreModal(true);
    },
  });

  const offerNotAcceptedProps: OfferNotAcceptedPageProps = {
    ...getOfferNotAcceptedProps(merchantData, expiresAt),
    onBackToOffer: () => setOpenOfferNotAccepted(false),
  };

  return openOfferNotAccepted ? (
    <OfferNotAcceptedPage {...offerNotAcceptedProps} />
  ) : (
    <>
      {getConfetti()}
      <ImpSpacer height="2xl" mobileHeight="xl" />
      {openInStoreModal && <InStoreModal sourcePage="offer" />}
      <ImpOfferPage {...offerPageProps} />
    </>
  );
}

//TODO: hard code for now; will fetch content from new BE api and move this function to a util file

const getOfferNotAcceptedProps = (
  merchantData: MerchantData,
  expiresAt: string
) => {
  return {
    cardImg: merchantData.cardImg,
    title: 'Take your time',
    subtitle: `This offer will be available until ${expiresAt}. Come back to accept your offer at ${webServicingDisplayURL}`,
    merchantName: merchantData.rewardDetails.merchantName,
  };
};
